/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { LaEdgeApiItem } from '../types';

export function edgesToNodeRequest(
  edges: LaEdgeApiItem[],
  sourceNodeId: string
): string[] {
  const sourceNodes = edges.map((edge) => edge.sourceNodeId);
  const targetNodes = edges.map((edge) => edge.targetNodeId);

  return [sourceNodeId, ...sourceNodes, ...targetNodes].filter(beUnique);
}

function beUnique(id: string, index: number, self: string[]): boolean {
  return index === self.findIndex((e) => e === id);
}
